import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
export default function PartnersPage() {
	return (
		<main className="flex-1">
			<section className="w-full py-12 md:py-24">
				<div className="container px-4 md:px-6">
					<div className="grid gap-6 lg:grid-cols-2 lg:gap-12 items-center">
						<div className="space-y-4 animate-fade-in">
							<h1 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl">
								Join us in Transforming Education for Students!
							</h1>
							<p className="text-muted-foreground md:text-lg">
								Join forces with Ighota!, a nonprofit dedicated
								to creating a digital platform offering free
								WAEC resources for West African students.
								Powered by the expertise of West African
								educators, Ighota ensures that students have
								access to high-quality educational materials at
								no cost.
							</p>
							<p className="text-muted-foreground md:text-lg">
								By partnering with us, your organization can
								help bridge educational gaps, support student
								success, and contribute to the development of
								future leaders. Together, we can make a lasting
								impact on education in West Africa. Partner with
								Ighota! today and be part of our transformative
								mission!
							</p>
							<div className="flex flex-col sm:flex-row gap-3">
								<Button
									size="lg"
									className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold"
									asChild>
									<Link to="/contact">Join Now!</Link>
								</Button>
								<Button variant="outline" size="lg" asChild>
									<Link to="/mission">Learn More</Link>
								</Button>
							</div>
						</div>
						<div className="relative h-full overflow-hidden rounded-lg shadow-xl">
							<img
								src="/placeholder.svg?height=800&width=1200&text=Partnership+img"
								alt="Partnership"
								fill
								className="object-cover"
								priority
							/>
						</div>
					</div>
				</div>
			</section>

			{/* Partnership Benefits */}
			{/* <section className="w-full py-12 bg-muted/50">
				<div className="container px-4 md:px-6">
					<div className="flex flex-col items-center justify-center space-y-4 text-center">
						<div className="space-y-2">
							<h2 className="text-3xl font-bold tracking-tighter sm:text-4xl">
								Partnership Benefits
							</h2>
							<p className="mx-auto max-w-[700px] text-muted-foreground md:text-lg">
								When you partner with Ighota!, you're investing
								in the future of education in West Africa.
							</p>
						</div>
					</div>
					<div className="mx-auto grid max-w-5xl gap-8 py-12 md:grid-cols-3">
						<Card className="card-hover-effect">
							<CardContent className="p-6 flex flex-col items-center text-center space-y-4">
								<div className="rounded-full bg-yellow-100 p-3 w-12 h-12 flex items-center justify-center">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
										className="text-yellow-600">
										<path d="M12 22v-5" />
										<path d="M9 8V2" />
										<path d="M15 8V2" />
										<path d="M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z" />
									</svg>
								</div>
								<h3 className="text-xl font-semibold">
									Brand Visibility
								</h3>
								<p className="text-muted-foreground">
									Showcase your commitment to education with
									prominent logo placement on our platform.
								</p>
							</CardContent>
						</Card>
						<Card className="card-hover-effect">
							<CardContent className="p-6 flex flex-col items-center text-center space-y-4">
								<div className="rounded-full bg-yellow-100 p-3 w-12 h-12 flex items-center justify-center">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
										className="text-yellow-600">
										<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
										<circle cx="9" cy="7" r="4" />
										<path d="M22 21v-2a4 4 0 0 0-3-3.87" />
										<path d="M16 3.13a4 4 0 0 1 0 7.75" />
									</svg>
								</div>
								<h3 className="text-xl font-semibold">
									Social Impact
								</h3>
								<p className="text-muted-foreground">
									Make a meaningful difference in the lives of
									thousands of students across West Africa.
								</p>
							</CardContent>
						</Card>
						<Card className="card-hover-effect">
							<CardContent className="p-6 flex flex-col items-center text-center space-y-4">
								<div className="rounded-full bg-yellow-100 p-3 w-12 h-12 flex items-center justify-center">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
										className="text-yellow-600">
										<path d="M12 2v20" />
										<path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
									</svg>
								</div>
								<h3 className="text-xl font-semibold">
									Tax Benefits
								</h3>
								<p className="text-muted-foreground">
									As a nonprofit organization, your
									contributions may be eligible for tax
									deductions.
								</p>
							</CardContent>
						</Card>
					</div>
				</div>
			</section> */}

			{/* Sponsors Section */}
			<section className="w-full py-12 md:py-24">
				<div className="container px-4 md:px-6">
					<div className="flex flex-col items-center justify-center space-y-4 text-center">
						<div className="space-y-2">
							<h2 className="text-3xl font-bold tracking-tighter sm:text-4xl">
								Our Sponsors!
							</h2>
							<p className="mx-auto max-w-[700px] text-muted-foreground md:text-lg">
								We're proud to partner with these organizations
								who share our vision for accessible education.
							</p>
						</div>
					</div>
					<div className="mx-auto grid max-w-5xl gap-8 py-12 md:grid-cols-3">
						<a
							href="https://street2school.org.ng"
							target="_blank"
							rel="noopener noreferrer"
							className="group">
							<div className="flex flex-col items-center justify-center p-6 h-40 bg-white rounded-lg border border-gray-200 shadow-sm transition-all duration-300 hover:shadow-md">
								<div className="relative h-24 w-full">
									<img
										src="/images/logos/partner_1.png"
										alt="Street2School"
										fill
										className="object-contain"
									/>
								</div>
								<p className="mt-2 text-sm font-medium text-muted-foreground group-hover:text-foreground transition-colors">
									Street2School
								</p>
							</div>
						</a>
						<a
							href="https://thepollinationproject.org/"
							target="_blank"
							rel="noopener noreferrer"
							className="group">
							<div className="flex flex-col items-center justify-center p-6 h-40 bg-white rounded-lg border border-gray-200 shadow-sm transition-all duration-300 hover:shadow-md">
								<div className="relative h-24 w-full">
									<img
										src="/images/logos/partner_2.jpg"
										alt="The Pollination Project"
										fill
										className="object-contain h-fit max-w-full"
									/>
								</div>
								<p className="mt-2 text-sm font-medium text-muted-foreground group-hover:text-foreground transition-colors">
									The Pollination Project
								</p>
							</div>
						</a>
						<a
							href="https://www.gse.harvard.edu/"
							target="_blank"
							rel="noopener noreferrer"
							className="group">
							<div className="flex flex-col items-center justify-center p-6 h-40 bg-white rounded-lg border border-gray-200 shadow-sm transition-all duration-300 hover:shadow-md">
								<div className="relative h-24 w-full">
									<img
										src="/images/logos/partner_3.png"
										alt="Harvard Graduate School of Education"
										fill
										className="object-contain"
									/>
								</div>
								<p className="mt-2 text-sm font-medium text-muted-foreground group-hover:text-foreground transition-colors">
									Harvard Graduate School of Education
								</p>
							</div>
						</a>
					</div>
				</div>
			</section>

			{/* CTA Section */}
			<section className="w-full py-16 md:py-24 bg-yellow-500">
				<div className="container px-4 md:px-6">
					<div className="flex flex-col items-center justify-center space-y-4 text-center">
						<div className="space-y-2">
							<h2 className="text-3xl font-bold tracking-tighter sm:text-4xl text-black">
								Ready to Make a Difference?
							</h2>
							<p className="mx-auto max-w-[700px] text-black/80 md:text-lg">
								Join our growing network of partners and help
								shape the future of education in West Africa.
							</p>
						</div>
						<div className="flex flex-col sm:flex-row gap-3">
							<Button
								size="lg"
								className="bg-black hover:bg-gray-800 text-white"
								asChild>
								<Link to="/contact">Become a Partner</Link>
							</Button>
							<Button
								variant="outline"
								size="lg"
								className="bg-transparent border-black text-black hover:bg-black/10"
								asChild>
								<Link to="https://www.gofundme.com/f/empower-nigerian-kids-with-virtual-learning-join-us">
									Make a Donation
								</Link>
							</Button>
						</div>
					</div>
				</div>
			</section>
		</main>
	);
}
